/* Extend Empire's carousel through its existing controls; product cards and purchase handlers stay native. */
(() => {
  if (window.onlyGamesCollectionRows) return;
  window.onlyGamesCollectionRows = true;
  const instances = new WeakMap();
  const selector = '[data-collection-row]';
  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const navigation = root.querySelector('[data-collection-navigation]');
    const surprise = root.querySelector('[data-collection-surprise]');
    const content = root.querySelector('[data-content]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let interacting = false;
    const sync = () => {
      root.querySelectorAll('.flickity-prev-next-button').forEach(button => {
        if (button.parentElement !== navigation) navigation.append(button);
      });
      navigation.hidden = !content.classList.contains('flickity-enabled');
    };
    const observer = new MutationObserver(sync);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (surprise) {
      surprise.hidden = false;
      surprise.addEventListener('click', () => {
        const links = [...content.querySelectorAll('.productitem--title a[href]')];
        if (!links.length) return;
        window.location.assign(links[Math.floor(Math.random() * links.length)].href);
      }, { signal });
    }
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      const seconds = Number(root.dataset.autoplayInterval);
      if (!seconds || motion.matches || window.Shopify?.designMode) return;
      timer = setInterval(() => {
        if (interacting || document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
        const bounds = root.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= innerHeight) return;
        if (!content.classList.contains('flickity-enabled')) return;
        const next = navigation.querySelector('.next');
        if (!next) return;
        if (!next.disabled) next.click();
        else {
          const previous = navigation.querySelector('.previous');
          let steps = 0;
          while (previous && !previous.disabled && steps++ < 30) previous.click();
        }
      }, seconds * 1000);
    };
    root.addEventListener('pointerdown', () => { interacting = true; }, { signal });
    document.addEventListener('pointerup', () => { interacting = false; }, { signal });
    root.addEventListener('keydown', stop, { signal });
    motion.addEventListener('change', start, { signal });
    instances.set(root, () => { stop(); observer.disconnect(); controller.abort(); instances.delete(root); });
    sync(); start();
  }
  const scan = scope => {
    if (scope.matches?.(selector)) mount(scope);
    scope.querySelectorAll?.(selector).forEach(mount);
  };
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll(selector).forEach(root => instances.get(root)?.()));
})();
